import { IUser } from 'core/model/interfaces/customer.interface';
import { IAuthState } from './types';

export const SLICE_NAMESPACE = 'auth';

export const authInitialState: IAuthState = {
  customer: null as any as IUser,
  loading: true,
  error: null,
  justLoggedIn: false,
  tokenVersion: 0,
};
